import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import TrustBar from "@/pages/home/components/TrustBar";
import RiskSection from "@/pages/home/components/RiskSection";
import Assessment from "@/pages/home/components/Assessment";
import Services from "@/pages/home/components/Services";
import Audience from "@/pages/home/components/Audience";
import Process from "@/pages/home/components/Process";
import LocalSection from "@/pages/home/components/LocalSection";
import Testimonials from "@/pages/home/components/Testimonials";
import Pricing from "@/pages/home/components/Pricing";
import Faq from "@/pages/home/components/Faq";
import Contact from "@/pages/home/components/Contact";
import Footer from "@/pages/home/components/Footer";
import ScrollToTop from "@/pages/home/components/ScrollToTop";
import MobileBar from "@/pages/home/components/MobileBar";

export default function Home() {
  return (
    <main className="bg-background-50 text-foreground-950 overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustBar />
      <RiskSection />
      <Assessment />
      <Services />
      <Audience />
      <Process />
      <LocalSection />
      <Testimonials />
      <Pricing />
      <Faq />
      <Contact />
      <Footer />
      <MobileBar />
      <ScrollToTop />
    </main>
  );
}